// extracted by mini-css-extract-plugin
export var defaultWrapper = "_kn-3";
export var downloadButton = "_kn-4";
export var fileContainer = "_kn-9 _kn-7";
export var fileContainerBase = "_kn-7";
export var fileContainerBaseSm = "_kn-a _kn-7";
export var fileContainerFixedHeight = "_kn-8 _kn-7";
export var fileContainerFixedHeightSm = "_kn-c _kn-a _kn-7";
export var fileContainerSm = "_kn-b _kn-a _kn-7";
export var fileInfo = "_kn-5";
export var fileInfoWidthRestricted = "_kn-6";
export var fileType = "_kn-1";
export var fileTypeName = "_kn-2";
export var fileTypeSm = "_kn-d _kn-1";
export var image = "_kn-0";
export var link = "_kn-f";
export var overflowEllipsis = "_kn-e";